import { useState, useEffect } from "react"
import { getTenantConfigJSON } from "./tenantConfig.helper";

function useLookBackWindow(tenantId, tool) {
    const key = "lookback_window";
    const [oldDate, setOldDate] = useState(null);

    const validateLookbackWindow = (lookbackWindow) => {
        const { value, interval } = lookbackWindow || {};

        const numValue = Number(value);

        if (
            !Number.isFinite(numValue) || numValue < 0 ||
            !interval || !["days", "weeks", "months", "years"].includes(interval.toLowerCase())
        ) {
            console.error("Invalid lookback window config:", lookbackWindow);
            return false;
        }

        return true;
    }

    const calculateLookBackWindow = (val, inter) => {
        let configDateStrategy = {
            days: (d, v) => d.setDate(d.getDate() - v),
            weeks: (d, v) => d.setDate(d.getDate() - v * 7),
            months: (d, v) => d.setMonth(d.getMonth() - v),
            years: (d, v) => d.setFullYear(d.getFullYear() - v)
        }
        
        const handler = configDateStrategy[inter.toLowerCase()];
        if(!handler) {
            console.error("Cannot get handler. Invalid interval,", inter);
            return null;
        }

        let date = new Date();

        handler(date, Number(val));

        return date.toISOString();
    }

    useEffect(() => {
        const loadLookBackWindow = async() => {
            //fetch from config.
            try {
                const response = await getTenantConfigJSON(tenantId, tool, [key]);
                const lookbackWindow = response.find(c => c.configKey === key)?.configVal;

                if(!validateLookbackWindow(lookbackWindow)) return null;

                //debug log
                console.log("lookback window from tenant config for", tool, lookbackWindow);

                //get value and interval
                const {value, interval} = lookbackWindow;

                //calculate date
                let lookbackDate = calculateLookBackWindow(value, interval);

                //set date
                setOldDate(lookbackDate);
                
            } catch (err) {
                console.error("Error fetching lookback window for", tool, err);
            }
        };

        loadLookBackWindow();
    }, [tenantId, tool]);

    return oldDate;
}

export default useLookBackWindow;